import React, { useRef } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import engine1 from "../../../../assets/images/engine/auxiliary-engine1.png";

const AuxillaryEngineSlider = () => {
  const containerRef = useRef(null);
  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);
  const scale = useMotionValue(1);
  const brightness = useMotionValue(100);

  const highlightColor = useTransform(
    [rotateX, rotateY],
    ([rx, ry]) => `hsl(${200 + Math.abs(rx * 5 + ry * 5)}, 80%, 90%)`
  );

  const handleMouseMove = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    animate(rotateX, y * 15);
    animate(rotateY, -x * 15);
    // animate(scale, 1.05);
    // animate(brightness, 120);
  };

  const handleMouseLeave = () => {
    animate(rotateX, 0);
    animate(rotateY, 0);
    animate(scale, 1);
    animate(brightness, 100);
  };

  return (
    <div className="flex w-[50%] items-center justify-center bg-white rounded-2xl shadow-xs border border-gray-100 p-8">
      <div className="relative rounded-2xl cursor-pointer transition-all duration-300 h-[100%]">
        <motion.div
          ref={containerRef}
          className="relative"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
          style={{ cursor: "pointer", height: "100%", display: "flex" }}
        >
          {/* Main image with 3D effects - Modified to reduce blur */}
          <motion.img
            src={engine1}
            alt="Marine Diesel Engine"
            className="max-w-full h-auto object-contain"
            style={{
              rotateX,
              rotateY,
              scale,
              filter: `
      brightness(${useTransform(brightness, (b) => b)}%)
      contrast(105%)
    `,
              transform: `
      perspective(2000px)
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      scale(${scale})
    `,
              transformStyle: "preserve-3d",
              backfaceVisibility: "hidden",
              imageRendering: "crisp-edges", // For pixel-perfect rendering
              willChange: "transform, filter", // Optimizes both transforms and filters
            }}
            initial={false} // Prevents animation on first render
          />

          {/* Dynamic blue highlight overlay */}
          <motion.div
            className="absolute inset-0 pointer-events-none mix-blend-soft-light"
            style={{
              background: highlightColor,
              opacity: useTransform([rotateX, rotateY], ([rx, ry]) =>
                Math.min(0.25, (Math.abs(rx) + Math.abs(ry)) / 80)
              ),
            }}
          />

          {/* Enhanced reflection effect */}
          <motion.div
            className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none"
            style={{
              opacity: useTransform([rotateX, rotateY], ([rx, ry]) =>
                Math.min(0.4, (Math.abs(rx) + Math.abs(ry)) / 40)
              ),
              background:
                "linear-gradient(to top, rgba(173,216,230,0.5), transparent)",
              maskImage: "linear-gradient(to top, black, transparent)",
            }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default AuxillaryEngineSlider;
